module.exports = __webpack_public_path__ + "static/media/cert1.81a4650c.png";